document.addEventListener('krumel:added', event => {
  const owner = event.target;
  const button = owner.querySelector('[type="submit"]');
  const label = button?.querySelector('[data-bag-label]');
  if (label) { label.textContent = 'Added ✓'; setTimeout(() => { if (label.isConnected) label.textContent = 'Add to bag'; }, 1800); }
  if (owner.dataset.krumelCrumb !== 'true' || !button || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const rect = button.getBoundingClientRect();
  for (let i = 0; i < 12; i++) {
    const dot = document.createElement('span'); dot.className = 'krumel-crumb'; dot.setAttribute('aria-hidden', 'true');
    dot.style.left = `${rect.left + rect.width / 2}px`; dot.style.top = `${rect.top + rect.height / 2}px`;
    dot.style.background = ['#bc8b53','#d8b682','#916139'][i % 3]; document.body.append(dot);
    const x = (Math.random() - .5) * 120;
    dot.animate([{transform:'translate(0,0)',opacity:1},{transform:`translate(${x*.6}px,-25px)`,opacity:1,offset:.35},{transform:`translate(${x}px,55px) rotate(160deg)`,opacity:0}],{duration:650 + Math.random()*250,easing:'ease-out'}).finished.then(() => dot.remove());
  }
});

document.addEventListener('click', event => {
  const stepper = event.target.closest('[data-krumel-step]');
  if (!stepper) return;
  const form = stepper.closest('form');
  const submit = form.querySelector('[type="submit"]');
  if (submit.classList.contains('loading')) return;
  const input = form.querySelector('[name="quantity"]');
  const min = Number(input.min) || 1;
  const step = Number(input.step) || 1;
  const max = input.max ? Number(input.max) : Infinity;
  const value = Math.max(min, Math.min(max, Number(input.value) + Number(stepper.dataset.krumelStep) * step));
  if (value !== Number(input.value)) {
    submit.classList.add('krumel-quantity-feedback');
    clearTimeout(submit.krumelWhiskTimer);
    submit.krumelWhiskTimer = setTimeout(() => {
      submit.classList.remove('krumel-quantity-feedback');
    }, 700);
  }
  input.value = String(value);
  form.querySelector('[data-krumel-count]').textContent = String(value);
  form.querySelector('[data-krumel-step="-1"]').disabled = value <= min;
  form.querySelector('[data-krumel-step="1"]').disabled = value + step > max;
});

// Native product-page quantity controls use the same whisk feedback.
document.addEventListener('change', event => {
  if (!event.target.matches('.quantity__input')) return;
  const formId = event.target.getAttribute('form');
  const form = formId && document.getElementById(formId);
  const button = form?.querySelector('.product-form__submit');
  if (!button || button.disabled || button.classList.contains('loading')) return;
  button.classList.add('krumel-quantity-feedback');
  clearTimeout(button.krumelWhiskTimer);
  button.krumelWhiskTimer = setTimeout(() => button.classList.remove('krumel-quantity-feedback'), 700);
});
